import React, { useState, useEffect, useCallback } from "react";
import { Select, Tabs, Table, Modal, Popover, Button, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import images from "../../themes/appImage";
import appconstant from "../../themes/appconstant";
import {
  proListLoad,
  updateProStatusLoad,
} from "../../redux/slices/managePros.slice";
import { imageURL } from "../../redux/Api/apikit";
import { debounce } from "../../utils/global-func";
import { useFormik } from "formik";
import * as Yup from "yup";

const { TabPane } = Tabs;

const ManagePros = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState();
  const { proList, proDashboard, proPagination, isLoading } = useSelector(
    (state) => state?.proReducer || {}
  );

  const [payload, setPayload] = useState({
    limit: 10,
    offset: 0,
    type: "requested",
    search: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [modalState, setModalState] = useState({
    approve: false,
    reject: false,
  });
  const [selectedPro, setSelectedPro] = useState(null);

  useEffect(() => {
    document.title = "MentalFit";
    dispatch(proListLoad(payload));
  }, [payload, dispatch]);

  const onChangePage = (page) => {
    if (
      page < 1 ||
      (proPagination &&
        page > Math.ceil(proPagination.totalCount / payload.limit))
    )
      return;
    setCurrentPage(page);
    setPayload((prev) => ({
      ...prev,
      offset: (page - 1) * prev.limit,
    }));
  };

  const onChangePageSize = (limit) => {
    setPayload((prev) => ({
      ...prev,
      limit: Number(limit),
      offset: 0,
    }));
    setCurrentPage(1);
  };

  const onUpdateStatus = (proId, status, reason = "") => {
    const statusPayload = { proId, status };
    if (reason) statusPayload.reason = reason;

    dispatch(updateProStatusLoad({ data: statusPayload, payload }));
    setModalState({ approve: false, reject: false });
    setSelectedPro(null);
  };

  const getColumns = useCallback(
    (tabKey) => {
      const commonColumns = [
        {
          title: "ID",
          dataIndex: "srno",
          key: "srno",
          render: (_, __, index) =>
            (proPagination?.currentPage - 1) * 10 + index + 1,
        },
        {
          title: () => (
            <div className="sort-icons">
              <span>Full Name</span>
              <img src={images.arrowLeft} alt="sort" />
            </div>
          ),
          dataIndex: "name",
          key: "name",
          sortDirections: ["ascend", "descend"],
          render: (_, record) => (
            <div className="organization-image-sec">
              <span>
                <img
                  crossOrigin="*"
                  src={imageURL + record?.avatar}
                  alt="user"
                  className="proImag"
                />
              </span>
              {record?.firstName + " " + record?.lastName || "N/A"}
            </div>
          ),
        },
        {
          title: "Username",
          dataIndex: "users",
          key: "users",
          render: (_, record) => (
            <div className="organization-link">{record?.userName || "N/A"}</div>
          ),
        },
        {
          title: "Email",
          dataIndex: "email",
          key: "email",
          render: (_, record) => (
            <div className="organization-link">{record?.email || "N/A"}</div>
          ),
        },
      ];

      const requestColumns = [
        {
          title: "Primary Expertise",
          dataIndex: "primary",
          key: "primary",
          render: (_, record) => (
            <div className="reomve-flex">
              {record?.primaryExpertise?.length === 0
                ? "N/A"
                : record?.primaryExpertise?.map((item) => item.name + ", ")}
            </div>
          ),
        },
        {
          title: "Secondary Expertise",
          dataIndex: "secondary",
          key: "secondary",
          render: (_, record) => (
            <div className="reomve-flex">
              {record?.secondaryExpertise?.length === 0
                ? "N/A"
                : record?.secondaryExpertise?.map((item) => item?.name + ", ")}
            </div>
          ),
        },
        {
          title: "License",
          dataIndex: "license",
          key: "license",
          render: (_, record) => (
            <div
              className="organization-link"
              onClick={() =>
                handleViewCertificates(imageURL + record?.certificate)
              }
            >
              <p>View License</p>
            </div>
          ),
        },
        {
          title: "Actions",
          key: "actions",
          render: (_, record) => (
            <div className="action-dots-iocn">
              <button
                type="submit"
                onClick={() => {
                  setSelectedPro(record);
                  setModalState((prev) => ({ ...prev, reject: true }));
                }}
              >
                {appconstant.reject}
              </button>
              <button
                className="approve-btn"
                type="submit"
                onClick={() => {
                  setSelectedPro(record);
                  setModalState((prev) => ({ ...prev, approve: true }));
                }}
              >
                {appconstant.approve}
              </button>
            </div>
          ),
        },
      ];

      const activeInactiveColumns = [
        {
          title: "Ratings",
          dataIndex: "rating",
          key: "rating",
          render: (rating) => (
            <div className="organization-image-sec remove-the-gap">
              <span>
                <img src={images.starFill} alt="star" />
              </span>
              {rating || "N/A"}
            </div>
          ),
        },
        {
          title: "Sessions",
          dataIndex: "totalSession",
          key: "totalSession",
          render: (totalSession) => totalSession || "N/A",
        },
        {
          title: "Hourly Rate",
          dataIndex: "hourlyRate",
          key: "hourlyRate",
          render: (hourlyRate) => hourlyRate || "N/A",
        },
        {
          title: "Earnings",
          dataIndex: "totalEarning",
          key: "totalEarning",
          render: (totalEarning) => totalEarning || "N/A",
        },
        {
          title: "Assign Organizations",
          dataIndex: "orgData",
          key: "orgData",
          render: (orgData) => orgData?.name || "N/A",
        },
        {
          title: "Actions",
          key: "actions",
          render: (_, record) => (
            <Popover
              content={
                <Button
                  type="text"
                  onClick={() => navigate(`/profiledetail/${record?.user}`)}
                >
                  View
                </Button>
              }
              trigger="click"
            >
              <div className="action-dots-iocn">
                {/* <span
                  onClick={() => navigate("/profiledetail")}
                  role="button"
                  tabIndex={0}
                  onKeyPress={(e) =>
                    e.key === "Enter" && navigate("/profiledetail")
                  }
                > */}
                <img src={images.horizontalDots} alt="actions" />
                {/* </span> */}
              </div>
            </Popover>
          ),
        },
      ];

      return tabKey === "1"
        ? [...commonColumns, ...requestColumns]
        : [...commonColumns, ...activeInactiveColumns];
    },
    [navigate, proPagination]
  );

  const TableFooter = () => {
    const totalCount = proPagination?.totalCount || 0;
    const from = totalCount === 0 ? 0 : (currentPage - 1) * payload.limit + 1;
    const to = Math.min(currentPage * payload.limit, totalCount);
    const totalPages = Math.ceil(totalCount / payload.limit);

    return (
      <div className="footer-section">
        <div className="foot-main-div">
          <div className="rows">
            <div className="row-per-page">
              <p>Rows per page</p>
            </div>
            <div className="top-checkbox fot-select">
              <Select
                value={String(payload.limit)}
                onChange={onChangePageSize}
                options={[
                  { value: "10", label: "10" },
                  { value: "15", label: "15" },
                  { value: "20", label: "20" },
                  { value: "25", label: "25" },
                ]}
              />
            </div>
          </div>
          <div className="page-count">
            <p>
              {from}-{to} of {totalCount}
            </p>
          </div>
          <div className="back-and-next">
            <span
              onClick={() => onChangePage(1)}
              style={{
                cursor: currentPage > 1 ? "pointer" : "not-allowed",
                opacity: currentPage > 1 ? 1 : 0.5,
              }}
            >
              <img src={images.next} className="rotate-180" alt="back" />
            </span>
            <span
              onClick={() => onChangePage(currentPage - 1)}
              style={{
                cursor: currentPage > 1 ? "pointer" : "not-allowed",
                opacity: currentPage > 1 ? 1 : 0.5,
              }}
            >
              <img src={images.new} className="rotate-180" alt="previous" />
            </span>
            <span
              onClick={() => onChangePage(currentPage + 1)}
              style={{
                cursor: currentPage < totalPages ? "pointer" : "not-allowed",
                opacity: currentPage < totalPages ? 1 : 0.5,
              }}
            >
              <img src={images.new} alt="next" />
            </span>
            <span
              onClick={() => onChangePage(totalPages)}
              style={{
                cursor: currentPage < totalPages ? "pointer" : "not-allowed",
                opacity: currentPage < totalPages ? 1 : 0.5,
              }}
            >
              <img src={images.next} alt="last" />
            </span>
          </div>
        </div>
      </div>
    );
  };

  const ApproveModal = ({ visible, onClose, onApprove }) => (
    <Modal
      title=""
      className="modal-update"
      centered
      open={visible}
      onCancel={onClose}
      footer={null}
      width={600}
    >
      <div className="add-user-popup">
        <div className="modal-add-user modal-top-space-ps">
          <h1>Do you surely want to approve?</h1>
        </div>
        <div className="schedule-send-now">
          <div className="send-now option-no">
            <button onClick={onClose}>No</button>
          </div>
          <div className="btn-schedule">
            <button onClick={onApprove}>Approve</button>
          </div>
        </div>
      </div>
    </Modal>
  );

  const RejectModal = React.memo(({ visible, onClose, onReject }) => {
    const onSubmit = (values) => {
      onUpdateStatus(
        selectedPro?.user || selectedPro?.id,
        "rejected",
        values?.rejectReason
      );
    };

    const rejectFormik = useFormik({
      initialValues: {
        rejectReason: "",
      },

      validationSchema: Yup.object({
        rejectReason: Yup.string()
          .min(3, "Reason must be at least 3 characters long.")
          .max(250, "Reason cannot exceed 250 characters.")
          .required("Please enter reason for rejection."),
      }),
      onSubmit,
    });

    return (
      <Modal
        title=""
        className="modal-update"
        centered
        open={visible}
        onCancel={onClose}
        footer={null}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Reject Pro Request</h1>
          </div>
          <form onSubmit={rejectFormik.handleSubmit}>
            <div className="description-inner-circle">
              <div className="wrapper_line">
                <div className="form-group">
                  <div className="textarea-label">
                    <label>{appconstant.rejectionReason}</label>
                    <p>{rejectFormik.values.rejectReason.length}/100</p>
                  </div>
                  <textarea
                    rows="5"
                    cols="50"
                    className="form-control-textarea"
                    placeholder="Add Reason"
                    name={"rejectReason"}
                    maxLength={100}
                    value={rejectFormik.values.rejectReason}
                    onChange={rejectFormik.handleChange}
                    onBlur={rejectFormik.handleBlur}
                  />

                  {rejectFormik?.errors?.rejectReason &&
                    rejectFormik?.touched?.rejectReason && (
                      <p className="text-red-600">
                        {rejectFormik?.errors?.rejectReason}
                      </p>
                    )}
                </div>
              </div>
            </div>
            <div className="click-to-upload">
              <div className="create-inner-circle-btn save-btn-mo">
                <button
                  type="submit"
                  disabled={
                    rejectFormik.values.rejectReason.trim().length === 0
                  }
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    );
  });

  const handleViewCertificates = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div className="site-layout-background">
      <div className="top-header-organi-zations">
        <div className="organi-zations-heading-text">
          <h1>Manage Pros</h1>
          <p>
            Sed consectetur imperdiet facilisiulla malesua daeddiet facilisiulla
          </p>
        </div>
      </div>
      <div className="total-user manage-pro-page">
        {[
          { label: "Total Pros", value: proDashboard?.activeProCount },
          {
            label: "Pros Pending Requests",
            value: proDashboard?.pendingProCount,
          },
          { label: "In Active Pros", value: proDashboard?.activeProCount },
          { label: "Total Earning", value: proDashboard?.totalEarning },
          { label: "Total Sessions", value: proDashboard?.totalSession },
        ].map((item) => (
          <div key={item.label} className="user-count number-inner-cricle-ps">
            <p>{item.label}</p>
            <h1>{item.value}</h1>
          </div>
        ))}
      </div>

      <section>
        <div className="slider-section manage-table-data">
          <div className="slider-tab-div">
            <Tabs
              onChange={(key) =>
                setPayload((prev) => ({
                  ...prev,
                  type:
                    key === "1"
                      ? "requested"
                      : key === "2"
                      ? "active"
                      : "inactive",
                  offset: 0,
                }))
              }
            >
              {[
                { key: "1", label: "Requests" },
                { key: "2", label: "Active Pros" },
                { key: "3", label: "In Active" },
              ].map(({ key, label }) => (
                <TabPane tab={label} key={key}>
                  <div className="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3 system-line">
                    <input
                      type="text"
                      className="iocn-search search-bar"
                      placeholder="Search"
                      value={searchValue}
                      onChange={(e) => {
                        setSearchValue(e.target.value.trimStart());
                        debounce(() =>
                          setPayload({ ...payload, search: e.target.value })
                        );
                      }}
                    />
                  </div>

                  {isLoading ? (
                    <Spin className="spin-table" />
                  ) : (
                    <Table
                      dataSource={proList}
                      columns={getColumns(key)}
                      pagination={false}
                      rowKey={(record) => record._id || record.id}
                      showSorterTooltip={false}
                    />
                  )}
                  <TableFooter />
                </TabPane>
              ))}
            </Tabs>
          </div>
        </div>
      </section>

      <ApproveModal
        visible={modalState.approve}
        onClose={() => setModalState((prev) => ({ ...prev, approve: false }))}
        onApprove={() =>
          onUpdateStatus(selectedPro?.user || selectedPro?.id, "approved")
        }
      />

      <RejectModal
        visible={modalState.reject}
        onClose={() => setModalState((prev) => ({ ...prev, reject: false }))}
        onReject={(reason) =>
          onUpdateStatus(
            selectedPro?.user || selectedPro?.id,
            "rejected",
            reason
          )
        }
      />
    </div>
  );
};

export default ManagePros;
